import { ɵɵdefineInjectable, ɵɵinject, Injectable, Inject, InjectionToken, EventEmitter, NgModule } from '@angular/core';
import { HttpParams, HttpClient, HttpResponse, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { map, filter, first, tap, takeWhile, switchMap } from 'rxjs/operators';
import moment from 'moment';
import { BehaviorSubject, Subject, timer } from 'rxjs';
import { flatMap } from 'rxjs/internal/operators';
import { Router } from '@angular/router';
import { DOCUMENT, CommonModule as CommonModule$1 } from '@angular/common';
import { NGXLogger } from 'ngx-logger';

// @ts-ignore
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@angular/router';
import * as ɵngcc3 from 'ngx-logger';
class DateUtils {
    static isLocalDate(date) {
        if (typeof date !== 'object') {
            return false;
        }
        return date.year !== undefined &&
            date.month !== undefined &&
            date.day !== undefined;
    }
    static isValidLocalDate(date) {
        return date.year > 1000 && date.month > 0 && date.month < 13 && date.day > 0 && date.day <= 31;
    }
    static localDateToMoment(localDate) {
        if (localDate == null) {
            return null;
        }
        const date = DateUtils.localDateToUtc(localDate);
        return moment(date);
    }
    static localDateToDate(localDate) {
        if (localDate == null) {
            return null;
        }
        if (!DateUtils.isLocalDate(localDate)) {
            return localDate;
        }
        const utc = DateUtils.localDateToUtc(localDate);
        return new Date(utc);
    }
    static localDateToUtc(date) {
        if (date == null) {
            return null;
        }
        return Date.UTC(date.year, date.month - 1, date.day);
    }
    static unixToLocalDate(unix) {
        if (unix == null) {
            return null;
        }
        const date = new Date(unix);
        return DateUtils.dateToLocalDate(date);
    }
    static dateToLocalDate(date) {
        if (date == null) {
            return null;
        }
        return {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate()
        };
    }
    static stringToLocalDate(string) {
        if (string == null) {
            return null;
        }
        return DateUtils.dateToLocalDate(moment(string).toDate());
    }
    static formatLocalDate(localDate, format) {
        if (localDate == null) {
            return null;
        }
        return DateUtils.localDateToMoment(localDate).format(format);
    }
    static formatDate(date, format) {
        return moment(date).format(format);
    }
    static formatDateAsDate(date) {
        return DateUtils.formatDate(date, DateUtils.DATE_FORMAT);
    }
    static formatLocalDateAsDate(localDate) {
        return DateUtils.formatLocalDate(localDate, DateUtils.DATE_FORMAT);
    }
    static localDateToIsoString(localDate) {
        return DateUtils.localDateToMoment(localDate).toISOString();
    }
    static formatHumanDate(date) {
        return DateUtils.formatDate(date, DateUtils.HUMAN_FORMAT);
    }
}
DateUtils.DATE_FORMAT = 'YYYY-MM-DD';
DateUtils.HUMAN_FORMAT = 'DD/MM/YYYY';

class StringUtils {
    static isEmpty(string) {
        return string == null || `${string}`.trim() === '';
    }
    static toAsciiNumber(string) {
        let number = '';
        const length = string.length;
        for (let i = 0; i < length; i++) {
            number += string.charCodeAt(i).toString(10);
        }
        return parseInt(number);
    }
    static fromAsciiNumber(ascii) {
        let string = '';
        const numeric = `${ascii}`;
        const length = numeric.length;
        for (let i = 0; i < length;) {
            const code = numeric.slice(i, i += 2);
            string += String.fromCharCode(parseInt(code, 10));
        }
        return string;
    }
}

class TimeUtils {
    static isTime(time) {
        return time.hour !== undefined &&
            time.minute !== undefined;
    }
    static toString(time) {
        if (time == null) {
            return null;
        }
        if (time.hour == null || time.minute == null) {
            return null;
        }
        let hour = `${time.hour}`;
        let minute = `${time.minute}`;
        if (time.hour < 10) {
            hour = `0${time.hour}`;
        }
        if (time.minute < 10) {
            minute = `0${time.minute}`;
        }
        return `${hour}:${minute}`;
    }
    static toTime(string) {
        const empty = {
            hour: null,
            minute: null,
        };
        if (StringUtils.isEmpty(string)) {
            return empty;
        }
        if (string.indexOf(':') === -1) {
            return empty;
        }
        const [hour, minute] = string.split(':');
        return {
            hour: isNaN(+hour) ? null : +hour,
            minute: isNaN(+minute) ? null : +minute
        };
    }
}

class HttpUtils {
    static toHttpParams(object) {
        let params = new HttpParams();
        if (object == null) {
            return params;
        }
        for (const key of Object.getOwnPropertyNames(object)) {
            params = HttpUtils.toHttpParam(params, key, object[key]);
        }
        return params;
    }
    static toHttpParam(params, key, value) {
        if (value == null) {
            return params;
        }
        if (DateUtils.isLocalDate(value)) {
            value = DateUtils.localDateToDate(value);
        }
        if (value instanceof Date || TimeUtils.isTime(value)) {
            params = params.set(key, HttpUtils.toParamValue(value));
        }
        else if (Array.isArray(value)) {
            for (const item of value) {
                if (value == null) {
                    continue;
                }
                params = HttpUtils.toHttpParam(params, `${key}`, item);
            }
        }
        else if (typeof value === 'object') {
            for (const objKey of Object.getOwnPropertyNames(value)) {
                if (value[objKey] == null) {
                    continue;
                }
                params = HttpUtils.toHttpParam(params, `${key}.${objKey}`, value[objKey]);
            }
        }
        else {
            params = params.set(key, HttpUtils.toParamValue(value));
        }
        return params;
    }
    static toParamValue(value) {
        if (value instanceof Date) {
            return DateUtils.formatDateAsDate(value);
        }
        if (TimeUtils.isTime(value)) {
            return TimeUtils.toString(value);
        }
        return value;
    }
}

class HttpService {
    constructor(http) {
        this.http = http;
    }
    get(url = '', options) {
        return this.http.get(this.buildEndpointUrl(`${url}`), options);
    }
    getBlob(url = '', param, options) {
        let params = '';
        if (param != null) {
            params = param.toString();
        }
        return this.http.get(this.buildEndpointUrl(`${url}?${params}`), {
            responseType: 'blob',
            observe: 'response'
        });
    }
    post(url = '', data) {
        return this.http.post(this.buildEndpointUrl(url), data);
    }
    put(url = '', data) {
        return this.http.put(this.buildEndpointUrl(url), data);
    }
    search(search) {
        const params = HttpUtils.toHttpParams(search);
        return this.get('', { params }).pipe(map((list) => this.convertListToModel(list)));
    }
    insert(resource) {
        return this.post('', resource).pipe(map((res) => this.convertResourceToModel(res)));
    }
    update(resource) {
        return this.put('', resource).pipe(map((res) => this.convertResourceToModel(res)));
    }
    deleteByIds(ids) {
        const params = [];
        for (const id of ids) {
            params.push(`ids=${id}`);
        }
        const queryString = params.join('&');
        return this.http.delete(this.buildEndpointUrl(`?${queryString}`));
    }
    buildGetParams(params) {
        const parts = [];
        for (let [key, value] of params) {
            parts.push(`${key}=${value}`);
        }
        return parts.join('&');
    }
    detail(id) {
        return this.get(`${id}`).pipe(map((res) => this.convertResourceToModel(res)));
    }
    delete(id) {
        return this.http.delete(this.buildEndpointUrl(`${id}`));
    }
    convertListToModel(list) {
        return list.map((resource) => this.convertResourceToModel(resource));
    }
    convertListToResource(list) {
        return list.map((model) => this.convertModelToResource(model));
    }
    buildEndpointUrl(url) {
        if (StringUtils.isEmpty(this.endpoint)) {
            return `${this.baseUrl}/${url}`;
        }
        return `${this.baseUrl}/${this.endpoint}/${url}`;
    }
}
HttpService.ɵfac = function HttpService_Factory(t) { return new (t || HttpService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
HttpService.ɵprov = ɵɵdefineInjectable({ factory: function HttpService_Factory() { return new HttpService(ɵɵinject(HttpClient)); }, token: HttpService, providedIn: "root" });
HttpService.ctorParameters = () => [
    { type: HttpClient }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HttpService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

class BaseModel {
}

class ApiResource {
}

class SelectableModel extends BaseModel {
    constructor() {
        super(...arguments);
        this.selected = false;
    }
}
function isSelectable(object) {
    return typeof object.selected !== 'undefined';
}

class PageableRequest {
}

class PageableResponse {
}

class PaginationInfo {
}

class User extends SelectableModel {
    constructor() {
        super(...arguments);
        this.enabled = true;
    }
}

// noinspection TypeScriptPreferShortImport
class Society extends SelectableModel {
    constructor(id, name, vatNumber = null) {
        super();
        this.id = id;
        this.name = name;
        this.vatNumber = vatNumber;
    }
}

class UserResource extends ApiResource {
    constructor() {
        super(...arguments);
        this.enabled = true;
    }
}

class UserService extends HttpService {
    constructor(http, baseUrl) {
        super(http);
        this.baseUrl = baseUrl;
        this.endpoint = 'users';
    }
    getSocieties() {
        return this.get('me/societies');
    }
    getOnlyChildSocieties() {
        const filters = `includeMemberships=false`;
        return this.get(`me/societies?${filters}`);
    }
    getSocietiesForGroupCodes(groupCodes) {
        const groupCodesParam = groupCodes.join(',');
        return this.get(`me/societies/for-groups?groupCodes=${groupCodesParam}`);
    }
    getRolesBySociety(societyId) {
        return this.get(`me/roles/${societyId}?type=PRIMARY`)
            .pipe(map((groups) => groups.filter((group) => group.selected)));
    }
    changePassword(request) {
        return this.put(`change-password`, request);
    }
    convertModelToResource(model) {
        return Object.assign(new UserResource(), model);
    }
    convertResourceToModel(resource) {
        return Object.assign(new User(), resource);
    }
}
UserService.ɵfac = function UserService_Factory(t) { return new (t || UserService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('FRAMEWORK_BASEURL')); };
UserService.ɵprov = ɵɵdefineInjectable({ factory: function UserService_Factory() { return new UserService(ɵɵinject(HttpClient), ɵɵinject("FRAMEWORK_BASEURL")); }, token: UserService, providedIn: "root" });
UserService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Inject, args: ['FRAMEWORK_BASEURL',] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UserService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Inject,
                args: ['FRAMEWORK_BASEURL']
            }] }]; }, null); })();

class SocietiesService extends HttpService {
    constructor(http, baseUrl, userService) {
        super(http);
        this.baseUrl = baseUrl;
        this.userService = userService;
        this.endpoint = 'societies';
        this.currentSocietySubject = new BehaviorSubject(null);
        this.currentSociety$ = this.currentSocietySubject.asObservable();
    }
    getAll() {
        return this.search();
    }
    getUserCompany() {
        return this.userService.getOnlyChildSocieties();
    }
    /**
     * Get currently selected society.
     * Filters out null values from currentSociety$
     */
    getSelectedSociety() {
        return this.currentSociety$.pipe(filter((society) => society != null));
    }
    setSociety(society) {
        this.currentSocietySubject.next(society);
    }
    convertModelToResource(model) {
        return model;
    }
    convertResourceToModel(resource) {
        return resource;
    }
}
SocietiesService.ɵfac = function SocietiesService_Factory(t) { return new (t || SocietiesService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('FRAMEWORK_BASEURL'), ɵngcc0.ɵɵinject(UserService)); };
SocietiesService.ɵprov = ɵɵdefineInjectable({ factory: function SocietiesService_Factory() { return new SocietiesService(ɵɵinject(HttpClient), ɵɵinject("FRAMEWORK_BASEURL"), ɵɵinject(UserService)); }, token: SocietiesService, providedIn: "root" });
SocietiesService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Inject, args: ['FRAMEWORK_BASEURL',] }] },
    { type: UserService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SocietiesService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Inject,
                args: ['FRAMEWORK_BASEURL']
            }] }, { type: UserService }]; }, null); })();

class GeneralSettingValueService extends HttpService {
    constructor(http, baseUrl) {
        super(http);
        this.baseUrl = baseUrl;
        this.endpoint = 'general-settings';
    }
    findByCode(code, societyId) {
        const params = {
            societyId: `${societyId}`
        };
        return this.get(`byCode/${code}`, { params });
    }
    convertModelToResource(model) {
        return Object.assign({}, model);
    }
    convertResourceToModel(resource) {
        return Object.assign({}, resource);
    }
}
GeneralSettingValueService.ɵfac = function GeneralSettingValueService_Factory(t) { return new (t || GeneralSettingValueService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('FRAMEWORK_BASEURL')); };
GeneralSettingValueService.ɵprov = ɵɵdefineInjectable({ factory: function GeneralSettingValueService_Factory() { return new GeneralSettingValueService(ɵɵinject(HttpClient), ɵɵinject("FRAMEWORK_BASEURL")); }, token: GeneralSettingValueService, providedIn: "root" });
GeneralSettingValueService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Inject, args: ['FRAMEWORK_BASEURL',] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GeneralSettingValueService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Inject,
                args: ['FRAMEWORK_BASEURL']
            }] }]; }, null); })();

class PageableService extends HttpService {
    constructor() {
        super(...arguments);
        this.paginationSubject = new Subject();
        this.pagination$ = this.paginationSubject.asObservable();
    }
    search(search) {
        const params = HttpUtils.toHttpParams(search);
        return this.get('', { params }).pipe(map((response) => this.extractPaginationInfo(response)), map((list) => this.convertListToModel(list)));
    }
    extractPaginationInfo(response) {
        this.paginationSubject.next({
            content: [],
            pageable: response.pageable,
            totalElements: response.totalElements,
            size: response.size,
            number: response.number,
            numberOfElements: response.numberOfElements
        });
        return response.content || [];
    }
}
PageableService.ɵfac = function PageableService_Factory(t) { return ɵPageableService_BaseFactory(t || PageableService); };
PageableService.ɵprov = ɵɵdefineInjectable({ factory: function PageableService_Factory() { return new PageableService(ɵɵinject(HttpClient)); }, token: PageableService, providedIn: "root" });
const ɵPageableService_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(PageableService);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PageableService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class QueueService {
    constructor() {
        this.listSubject = new BehaviorSubject([]);
        this.list$ = this.listSubject.asObservable();
    }
    clear() {
        this.listSubject.next([]);
    }
    isEmpty() {
        return this.listSubject.getValue().length === 0;
    }
    isNotEmpty() {
        return !this.isEmpty();
    }
    count() {
        return this.listSubject.getValue().length;
    }
}
QueueService.ɵfac = function QueueService_Factory(t) { return new (t || QueueService)(); };
QueueService.ɵprov = ɵɵdefineInjectable({ factory: function QueueService_Factory() { return new QueueService(); }, token: QueueService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(QueueService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const DOWNLOAD_BASEURL = new InjectionToken('Download service base URL');

var DownloadStatusEnum;
(function (DownloadStatusEnum) {
    DownloadStatusEnum["INIT"] = "INIT";
    DownloadStatusEnum["READY"] = "READY";
    DownloadStatusEnum["ERROR"] = "ERROR";
})(DownloadStatusEnum || (DownloadStatusEnum = {}));

class DownloaderService extends QueueService {
    constructor(http, baseUrl) {
        super();
        this.http = http;
        this.baseUrl = baseUrl;
        this.FILENAME_REGEX = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        this.queue = [];
        this.onDownloadCompleted = new EventEmitter();
    }
    removeById(id) {
        this.queue = this.queue.filter(item => item.id !== id);
    }
    removeAll() {
        this.queue = [];
    }
    getQueue() {
        return this.queue;
    }
    addToQueue(item) {
        this.queue.push(item);
    }
    get isDownloading() {
        return this.queue.filter(val => val.isProgress).length > 0;
    }
    get isError() {
        return this.hasItems && !this.isDownloading && this.queue.filter((item) => item.isError).length > 0;
    }
    get isSuccess() {
        return this.hasItems && !this.isDownloading && !this.isError;
    }
    get totalItemsCount() {
        return this.queue.length;
    }
    get hasItems() {
        return this.totalItemsCount > 0;
    }
    exportList(endpoint, search) {
        const url = `${this.baseUrl}/${endpoint}/download-export-csv`;
        return this.http.post(url, search)
            .pipe(first(), tap((status) => {
            this.download({
                id: status.id,
                token: status.token,
                fileName: status.fileName,
                url: endpoint + '/download'
            });
        }));
    }
    exportDetail(endpoint, search) {
        const url = `${this.baseUrl}/${endpoint}/download-export-csv-detail`;
        return this.http.post(url, search)
            .pipe(first(), tap((status) => {
            this.download({
                id: status.id,
                token: status.token,
                fileName: status.fileName,
                url: endpoint + '/download'
            });
        }));
    }
    downloadElements(items, params) {
        let ids = [];
        let path = '';
        if (Array.isArray(items) && items.length) {
            ids = items.map((item) => item.id);
            path = items[0].url;
        }
        else {
            ids = [items.id];
            path = items.url;
        }
        const url = `${this.baseUrl}/${path}`;
        return this.http.post(url, Object.assign({ ids }, params))
            .pipe(first(), tap((status) => {
            this.download({
                id: status.id,
                token: status.token,
                fileName: status.fileName,
                url: path
            });
        }));
    }
    getDownloadStatus(item) {
        const request = {
            id: item.id
        };
        const url = `${this.baseUrl}/${item.url}/status`;
        return this.http.post(url, request)
            .pipe(first());
    }
    download(item) {
        this.addToQueue(item);
        this.startDownloading();
    }
    downloadMultiple(items) {
        for (const item of items) {
            this.addToQueue(item);
        }
        this.startDownloading();
    }
    startDownloading() {
        const items = this.queue.filter(item => !item.isProgress);
        for (const item of items) {
            if (item.isError || item.isSuccess) {
                continue;
            }
            item.isProgress = true;
            const call = timer(0, 2000)
                .pipe(flatMap(() => this.getDownloadStatus(item).pipe(takeWhile(val => val.status === DownloadStatusEnum.READY || val.status === DownloadStatusEnum.ERROR), tap(val => {
                item.fileName = val.fileName;
                item.isError = val.status === DownloadStatusEnum.ERROR;
                item.isSuccess = val.status === DownloadStatusEnum.READY;
                if (val.url) {
                    item.url = val.url;
                }
            }))), first(), switchMap(value => {
                return this.downloadByToken(value.token, item.url);
            }))
                .subscribe((res) => {
                item.isProgress = false;
                if (item.isSuccess) {
                    if (!StringUtils.isEmpty(res.fileName)) {
                        item.fileName = res.fileName;
                    }
                    item.url = res.url;
                    if (!StringUtils.isEmpty(item.fileName) && item.fileName.endsWith('.csv')) {
                        item.blob = new Blob(['\ufeff', res.rawData]);
                    }
                    else {
                        item.blob = new Blob([res.rawData]);
                    }
                    item.rawData = res.rawData;
                    call.unsubscribe();
                    this.onDownloadCompleted.emit(item);
                }
            }, error => {
                console.error(error);
                item.isSuccess = false;
                item.isProgress = false;
                item.isError = true;
            });
        }
    }
    downloadById(id, endpoint) {
        const params = HttpUtils.toHttpParams({ id });
        const url = `${this.baseUrl}/${endpoint}/byId`;
        return this.downloadBlob(url, params);
    }
    downloadByToken(token, endpoint) {
        const params = HttpUtils.toHttpParams({ token });
        const url = `${this.baseUrl}/${endpoint}/byToken`;
        return this.downloadBlob(url, params);
    }
    downloadBlob(url, params) {
        return this.getBlob(url, params)
            .pipe(map((response) => {
            let fileName = '';
            const contentDisposition = response.headers.get('Content-Disposition');
            const matches = this.FILENAME_REGEX.exec(contentDisposition);
            if (matches != null && matches[1]) {
                fileName = matches[1].replace(/['"]/g, '');
            }
            const blob = new Blob(['\ufeff', response.body]);
            const rawData = response.body;
            return {
                rawData,
                blob,
                url: URL.createObjectURL(blob),
                fileName
            };
        }));
    }
    getBlob(url, params, options) {
        return this.http.get(url, {
            params,
            responseType: 'blob',
            observe: 'response'
        }).pipe(first());
    }
    clear() {
        this.removeAll();
    }
    isEmpty() {
        return !this.isNotEmpty();
    }
    isNotEmpty() {
        return this.hasItems;
    }
    count() {
        return this.totalItemsCount;
    }
}
DownloaderService.ɵfac = function DownloaderService_Factory(t) { return new (t || DownloaderService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(DOWNLOAD_BASEURL)); };
DownloaderService.ɵprov = ɵɵdefineInjectable({ factory: function DownloaderService_Factory() { return new DownloaderService(ɵɵinject(HttpClient), ɵɵinject(DOWNLOAD_BASEURL)); }, token: DownloaderService, providedIn: "root" });
DownloaderService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Inject, args: [DOWNLOAD_BASEURL,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DownloaderService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Inject,
                args: [DOWNLOAD_BASEURL]
            }] }]; }, null); })();

/** @dynamic */
class RedirectService {
    constructor(document, router) {
        this.document = document;
        this.router = router;
    }
    /** The Window object from Document defaultView */
    get window() {
        return this.document.defaultView || window;
    }
    /** Redirects instantly to the external link without the mediation of the router */
    redirect(url, target = '_blank') {
        return new Promise((resolve, reject) => {
            try {
                this.window.location.href = url;
                resolve(true);
            }
            catch (e) {
                reject(e);
            }
        });
    }
    /** Returns true if the given url looks external */
    external(url) {
        return /^http(?:s)?:\/{2}\S+$/.test(url);
    }
    /** Parses the given url for external redirection */
    externalUrl(url, target) {
        // Builds the redirection url for canActivate() to handle it
        return 'redirect?url=' + url + (!!target ? '&=' + target : '');
    }
    /** Parses the given url for internal routing */
    internalUrl(url) {
        // Handles '#' anchors and '.' relative urls by prepending the current url from the router
        return url && url.startsWith('#') ? (this.router.url.replace(/#.*$/, '') + url) : (url && url.replace(/^\./, this.router.url));
    }
    /** Navigates to the given url, redirecting when necessary
     * @param url An absolute URL. The function does not apply any delta to the current URL.
     * When starting with 'http(s)://' triggers the external redirection.
     * @param extras (optional). An object containing properties that modify the navigation strategy.
     * The function ignores any properties that would change the provided URL.
     */
    navigate(url, extras) {
        // Compose the url link for redirection
        const link = this.external(url) ? this.externalUrl(url, extras === null || extras === void 0 ? void 0 : extras.target) : this.internalUrl(url);
        // Navigates with the router activating the redirection guard
        return this.router.navigateByUrl(link, extras);
    }
    canActivate(route) {
        // Gets the url query parameter, if any
        const url = route.queryParamMap.get('url');
        // If the url matches an external link, redirects stopping the route activation
        if (this.external(url)) {
            // Verifies whenever the external url may be redirected internally (since the origin matches)
            // const rx = new RegExp(`^${this.window.location.origin}`);
            // if (url.match(rx)) {
            //   return this.router.parseUrl(url.replace(rx, ''));
            // }
            // Gets the optional target, when specified
            const target = route.queryParamMap.get('target');
            // Jumps to the external resource
            return this.redirect(url, target).then(() => false);
        }
        // Goes on activating the requested route, most likely to NotFound
        return true;
    }
}
RedirectService.ɵfac = function RedirectService_Factory(t) { return new (t || RedirectService)(ɵngcc0.ɵɵinject(DOCUMENT), ɵngcc0.ɵɵinject(ɵngcc2.Router)); };
RedirectService.ɵprov = ɵɵdefineInjectable({ factory: function RedirectService_Factory() { return new RedirectService(ɵɵinject(DOCUMENT), ɵɵinject(Router)); }, token: RedirectService, providedIn: "root" });
RedirectService.ctorParameters = () => [
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: Router }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RedirectService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc2.Router }]; }, null); })();

class CacheService {
    constructor() {
        this.cache = new Map();
    }
    has(key) {
        return this.cache.has(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    get(key) {
        return this.cache.get(key);
    }
    forget(key) {
        this.cache.delete(key);
    }
}
CacheService.ɵfac = function CacheService_Factory(t) { return new (t || CacheService)(); };
CacheService.ɵprov = ɵɵdefineInjectable({ factory: function CacheService_Factory() { return new CacheService(); }, token: CacheService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CacheService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class LoggerInterceptor {
    constructor(logger) {
        this.logger = logger;
    }
    intercept(req, next) {
        this.logger.debug('request', req);
        return next.handle(req).pipe(map((event) => {
            if (event instanceof HttpResponse) {
                this.logger.debug('response', event);
            }
            return event;
        }));
    }
}
LoggerInterceptor.ɵfac = function LoggerInterceptor_Factory(t) { return new (t || LoggerInterceptor)(ɵngcc0.ɵɵinject(ɵngcc3.NGXLogger)); };
LoggerInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: LoggerInterceptor, factory: LoggerInterceptor.ɵfac });
LoggerInterceptor.ctorParameters = () => [
    { type: NGXLogger }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LoggerInterceptor, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc3.NGXLogger }]; }, null); })();

class CommonModule {
}
CommonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CommonModule });
CommonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CommonModule_Factory(t) { return new (t || CommonModule)(); }, imports: [[
            CommonModule$1,
            HttpClientModule
        ],
        CommonModule$1,
        HttpClientModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CommonModule, { imports: function () { return [CommonModule$1,
        HttpClientModule]; }, exports: function () { return [CommonModule$1,
        HttpClientModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CommonModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [
                    CommonModule$1,
                    HttpClientModule
                ],
                exports: [
                    CommonModule$1,
                    HttpClientModule
                ]
            }]
    }], null, null); })();

class HttpInterceptorsModule {
}
HttpInterceptorsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: HttpInterceptorsModule });
HttpInterceptorsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function HttpInterceptorsModule_Factory(t) { return new (t || HttpInterceptorsModule)(); }, providers: [
        { provide: HTTP_INTERCEPTORS, useClass: LoggerInterceptor, multi: true },
    ], imports: [[]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HttpInterceptorsModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [],
                providers: [
                    { provide: HTTP_INTERCEPTORS, useClass: LoggerInterceptor, multi: true },
                ]
            }]
    }], null, null); })();

var GeneralSettingType;
(function (GeneralSettingType) {
    GeneralSettingType["TEXT"] = "TEXT";
    GeneralSettingType["PASSWORD"] = "PASSWORD";
})(GeneralSettingType || (GeneralSettingType = {}));

var ActivityEnum;
(function (ActivityEnum) {
    ActivityEnum["INSERT"] = "INSERT";
    ActivityEnum["DELETE"] = "DELETE";
    ActivityEnum["UPDATE"] = "UPDATE";
    ActivityEnum["VIEW"] = "VIEW";
    ActivityEnum["CUSTOM"] = "CUSTOM";
})(ActivityEnum || (ActivityEnum = {}));

var UserTypeEnum;
(function (UserTypeEnum) {
    UserTypeEnum["BANKING_OPERATOR"] = "BANKING_OPERATOR";
    UserTypeEnum["PRIVATE_CONDOMINIUM"] = "PRIVATE_CONDOMINIUM";
    UserTypeEnum["COMPANY"] = "COMPANY";
    UserTypeEnum["PARTNER"] = "PARTNER";
    UserTypeEnum["PARTNER_ADVISORY"] = "PARTNER_ADVISORY";
    UserTypeEnum["TECH_OPERATOR"] = "TECH_OPERATOR";
    UserTypeEnum["PWC_OPERATOR"] = "PWC_OPERATOR";
    UserTypeEnum["DELEGATE"] = "DELEGATE";
    UserTypeEnum["LEGAL_REPRESENTATIVE"] = "LEGAL_REPRESENTATIVE";
    UserTypeEnum["OPERATING_USER"] = "OPERATING_USER";
})(UserTypeEnum || (UserTypeEnum = {}));

/*
 * Public API Surface of @pwc/common
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ActivityEnum, ApiResource, BaseModel, CacheService, CommonModule, DOWNLOAD_BASEURL, DateUtils, DownloadStatusEnum, DownloaderService, GeneralSettingType, GeneralSettingValueService, HttpInterceptorsModule, HttpService, HttpUtils, LoggerInterceptor, PageableRequest, PageableResponse, PageableService, PaginationInfo, QueueService, RedirectService, SelectableModel, SocietiesService, Society, StringUtils, TimeUtils, User, UserService, UserTypeEnum, isSelectable };

//# sourceMappingURL=pwc-common.js.map